// Constantes & helpers partagés pour la validation des experts
export const CATEGORIES_EXPERTISE = [
  { value: 'rapport', label: 'Rapport', color: 'bg-blue-600', icon: '\ud83d\udccb' },
  { value: 'veille', label: 'Veille', color: 'bg-green-700', icon: '\ud83d\udc41\ufe0f' },
  { value: 'conseil', label: 'Conseil', color: 'bg-purple-600', icon: '\ud83d\udca1' },
  { value: 'audit', label: 'Audit', color: 'bg-orange-600', icon: '\ud83d\udd0d' },
  { value: 'evaluation', label: '\u00c9valuation', color: 'bg-pink-600', icon: '\ud83d\udcca' }
];

export const calculateQualityScore = (expert) => {
  let score = 0;
  let total = 0;
  if (expert.numero_agrement) { score++; total++; } else { total++; }
  if (expert.specialites?.length > 0) { score++; total++; } else { total++; }
  if (expert.categories_expertise?.length > 0) { score++; total++; } else { total++; }
  if (expert.experience_annees > 0) { score++; total++; } else { total++; }
  if (expert.raison_sociale) { score++; total++; } else { total++; }
  return Math.round((score / total) * 100);
};
